import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-weather-marine-card-days")
	.forEach((el) => {
		const root = el.querySelector(".marine-card-days__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
